import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Logging } from '../../../logging';
import { ApiService } from '../../../shared/api-service/api.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { SearchService } from '../../../shared/search/search.service';
import { ComponentID, ActionType, PermissionHelper } from '../../../shared/helpers/permissionshelper';

declare var jquery:any;
declare var $ :any;
declare var App:any;
declare var FormSliderSwitcher:any;

@Component({
  selector: 'app-cashout-add',
  templateUrl: './cashout-add.component.html',
  styleUrls: ['./cashout-add.component.css']
})
export class CashoutAddComponent implements OnInit {

  inputform:  FormGroup;
  showErrors :Boolean = false;
  loading: boolean;
  hasError: boolean;
  errorMessage: any;
  successMessage : any;
  campaigns: any[];
  dynamicbeneficiaries: any[];
  beneficiaries : any[] = [];
  appbalance : number;
  appbalances : any[];
  

  
  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private searchService: SearchService,private componentid : ComponentID ,
    private actiontype: ActionType,private permhelper:PermissionHelper) { }

  ngOnInit() {
    //this.helpers.flashWarningCustom("We have a temporary issue on our Instant Pay Channel. Pay outs will go through manual clearing by your destination bank",600000);
    this.fetchAppBalances();
    this.inputform = new FormGroup({
      amount: new FormControl('',[Validators.required, Validators.min(1)]),
      appid: new FormControl('',Validators.required),
      beneficiaryid: new FormControl('',Validators.required),
      channel: new FormControl('', Validators.required),
      reference: new FormControl('', [Validators.required,Validators.pattern("[a-zA-Z0-9]*")]),
      description: new FormControl('',Validators.pattern("[a-zA-Z0-9 ]*")),
    });

    $(".default-select2").select2();

     //catch the select 2 onchange event
     var self = this;
     $('#beneficiaryid').on("change", function() { 
      self.inputform.controls.beneficiaryid.setValue($(this).val());
    });

    this.getApps();
  }

  clearPreviousBeneficiary()
  {
    $('#beneficiaryid').attr('val','').trigger('change');
  }

  fetchAppBalances()
  {
    this.api.get('/accounts/'+ this.auth.getAccountID() + '/balancedetails')
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      this.appbalances = res_data.data;
      }, error_message => {
        
      }
    );
  }

  getAppBalance(appid : any)
  {
    this.appbalance  = 0;
    this.inputform.controls.amount.setValue("");
    this.appbalances.forEach(b => {
      if(b.appid == appid)
      {
        this.appbalance =  b.availablebalance;
      }
    });

    if(this.appbalance <= 0)
    {
      $('.myelem').attr('disabled','true');
    }
    else
    {
      $('.myelem').removeAttr('disabled');
    }
  }

  getApps(){
  
    this.api.get('/campaigns/accounts/'+ this.auth.getAccountID() + '/apps')
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      this.campaigns = res_data.data.content;
      }, error_message => {
        
      }
    );
  }

  getBeneficiaries(channel : any)
  {
    this.beneficiaries = [];
    this.inputform.controls.beneficiaryid.setValue("");
    this.clearPreviousBeneficiary();
     Logging.log(channel);
     if(channel == "BANK")
     {
        this.getBankBeneficiaries(channel);
     }
     if(channel == "MOBILE_MONEY")
     {
      this.getMobileBeneficiaries(channel);
     }
     

  }


  getBankBeneficiaries(channel : any)
  {
    this.api.get('/accounts/'+ this.auth.getAccountID() +'/bankaccounts?sort=accountname,asc&page=0&size=1000')
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      this.dynamicbeneficiaries = res_data.data.content;
      this.dynamicbeneficiaries.forEach(ben => {
      this.beneficiaries.push({'id':ben.id,'name':ben.bankname + ' - '+ ben.accountname + ' ('+ ben.branch + ')'})
      });

      }, error_message => {
        
      }
    );
  }

  getMobileBeneficiaries(channel : any)
  {
    this.api.get('/accounts/'+ this.auth.getAccountID() +'/wallets?sort=wallet,asc&page=0&size=1000')
     .subscribe(
       res_data => {
       Logging.log(res_data.data);
       this.dynamicbeneficiaries = res_data.data.content;
       this.dynamicbeneficiaries.forEach(ben => {
        this.beneficiaries.push({'id':ben.id,'name':ben.brandgroup + ' - '+ ben.wallet})
      });
       }, error_message => {
         
       }
     );
  }


  clearErrors()
  {
    this.errorMessage = "";
    this.hasError = false;
    this.showErrors = true;
  }

  verifydetails()
  {
    this.hasError = false;
    Logging.log(this.inputform.value);
    const regfields = this.inputform.value;
    this.showErrors = true;

    if(this.appbalance == null || this.appbalance == undefined)
    {
      this.inputform.controls.amount.setErrors({'incorrect': true});
      this.inputform.controls.appid.setErrors({'incorrect': true});
    
     
     // this.errorMessage ="Please select appropriate app";
      return;
    }

    if(regfields.amount > this.appbalance || regfields.amount <= 0)
    {
      this.inputform.controls.amount.setErrors({'incorrect': true});
      //this.errorMessage ="Invalid amount specified. Check and try again";
     
      
      return;
    }
    Logging.log("Aount:=>"+ regfields.amount + ", "+ this.appbalance);

    if(this.inputform.valid)
    {
      $("#confirmation").modal({
        escapeClose: false,
        clickClose: false,
        showClose: false
      });
    }
    else
    {
     
      this.hasError = false;
      this.showErrors = true;
      Logging.log('Has Errors', this.inputform.value);
    }

  }

  onSubmit()
  {

    this.loading = true;
    this.hasError = false;
    Logging.log(this.inputform.value);
    const regfields = this.inputform.value;
    this.showErrors = true;

    if(this.appbalance == null || this.appbalance == undefined)
    {
      this.inputform.controls.amount.setErrors({'incorrect': true});
      this.inputform.controls.appid.setErrors({'incorrect': true});
      this.loading = false;
     
     
     // this.errorMessage ="Please select appropriate app";
      return;
    }

    if(regfields.amount > this.appbalance || regfields.amount <= 0)
    {
      this.inputform.controls.amount.setErrors({'incorrect': true});
      //this.errorMessage ="Invalid amount specified. Check and try again";
      this.loading = false;
      
      return;
    }
    Logging.log("Aount:=>"+ regfields.amount + ", "+ this.appbalance);

    if(this.inputform.valid){
     

      const requestpayload = {
        userid: this.auth.getUserID(),
        amount: regfields.amount,
        appid : regfields.appid,
        beneficiaryid : regfields.beneficiaryid,
        channel : regfields.channel,
        description : regfields.description,
        reference :regfields.reference
      };

      $('#pmtinit').attr('disabled',true);
      this.api.post('/accounts/'+ this.auth.getAccountID() +'/uicashout',requestpayload)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.helpers.flashSuccess(res_data.data[0].value);
        if(res_data.data[0].key == "OTP_SENT")
        {
          //will redirect for him to approve
          this.router.navigate(['/cashout/' + res_data.data[0].value2 + '/approve']);
        }
        else if(res_data.data[0].key == "APPROVAL_EMAIL_SENT")
        {
            this.router.navigate(['/cashout/pending']);
        }
        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
          $('#pmtinit').removeAttr('disabled');
        }

      );
    }
    else
    {
      this.loading = false;
      this.hasError = false;
      this.showErrors = true;
      Logging.log('Has Errors', this.inputform.value);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/client/cashout/cashout-add/cashout-add.component.ts